var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_11180)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6477 3.47725C11.8674 3.69692 11.8674 4.05308 11.6477 4.27275L8.64775 7.27275C8.59097 7.32953 8.52269 7.37349 8.44751 7.40168L5.56159 8.4839L4.9205 9.125L9.375 13.5795L10.0161 12.9384L11.0983 10.0525C11.1265 9.97731 11.1705 9.90903 11.2273 9.85225L14.2273 6.85225C14.4469 6.63258 14.8031 6.63258 15.0227 6.85225C15.2424 7.07192 15.2424 7.42808 15.0227 7.64775L12.1089 10.5616L11.0267 13.4475C10.9985 13.5227 10.9545 13.591 10.8977 13.6477L9.77275 14.7727C9.55308 14.9924 9.19692 14.9924 8.97725 14.7727L3.72725 9.52275C3.50758 9.30308 3.50758 8.94692 3.72725 8.72725L4.85225 7.60225C4.90903 7.54547 4.97731 7.50151 5.05249 7.47332L7.93841 6.3911L10.8523 3.47725C11.0719 3.25758 11.4281 3.25758 11.6477 3.47725Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14775 11.3523C7.36742 11.5719 7.36742 11.9281 7.14775 12.1477L3.77275 15.5227C3.55308 15.7424 3.19692 15.7424 2.97725 15.5227C2.75758 15.3031 2.75758 14.9469 2.97725 14.7273L6.35225 11.3523C6.57192 11.1326 6.92808 11.1326 7.14775 11.3523Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4773 3.10225C10.6969 2.88258 11.0531 2.88258 11.2727 3.10225L15.3977 7.22725C15.6174 7.44692 15.6174 7.80308 15.3977 8.02275C15.1781 8.24242 14.8219 8.24242 14.6023 8.02275L10.4773 3.89775C10.2576 3.67808 10.2576 3.32192 10.4773 3.10225Z",
    fill: "#6B6B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_11180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.dab5cdef86067dd98329ce8b856751b2.svg";
export { ForwardRef as ReactComponent };